import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/precisionmarketing';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async logs(params: any) {
    return api.logs(params);
  }

  @Action
  async complaints(params: any) {
    return api.complaints(params);
  }
}
